import { makeVar } from '@apollo/client';

export const failedQueries = makeVar<Record<string, boolean>>({});
